export const tagsToString = (tags: string[]): string =>
  tags
    .map((tag) => `#${tag}`)
    .sort((a, b) => a.localeCompare(b))
    .join(' ');
